import React,{useState, useCallback} from "react";
import Modal from "react-modal";

import {
    Container,
    Close,
    TitleBlack,
    SubTitle,
    ButtonContainerTop,
    ButtonDelete,
    ButtonOK,
    GridTitle
  } from './styles';

import ButtonX from "../Images/ButtonX.svg"
interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onRequestCloseDelete: () => void;

}

export default function ModalConfirmDeleteProduct( { isOpen, onRequestClose, onRequestCloseDelete }: ModalProps ) {

  const [isClose] = useState(false);

  const handleExit = useCallback(() => {
        onRequestClose();
  },[onRequestClose]);

  const handleDelete = useCallback(() => {
    onRequestCloseDelete();
},[onRequestCloseDelete]);

  return (
    <>

    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        if (isClose===true) {
          onRequestClose();
        }
      }}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: "modal-base-delete",
        afterOpen: "modal-base_after-open",
        beforeClose: "modal-base_before-close"
      }}
      overlayClassName={{
        base: "overlay-base",
        afterOpen: "overlay-base_after-open",
        beforeClose: "overlay-base_before-close"
      }}
      shouldCloseOnOverlayClick={true}
    >

      <Container>
        <GridTitle>
            <TitleBlack>Excluir proposta</TitleBlack>
            <Close onClick={handleExit}>
                    <img 
                    alt={""} 
                    src={ButtonX}
                    width={15}
                    height={15}
                    >
                    </img>
                </Close>
        </GridTitle>
        <br/>
          <SubTitle>Deseja realmente excluir esta proposta?</SubTitle>
          <br/><br/>
          <ButtonContainerTop>
          
          <ButtonDelete onClick={() => handleExit()} >Cancelar</ButtonDelete>
          <ButtonOK onClick={() => handleDelete()} >Sim, excluir</ButtonOK> 
        </ButtonContainerTop>

        </Container>

    </Modal>
    </>
  )
  }